(() => {
  if (customElements.get('okova-value-block')) return;
  customElements.define('okova-value-block', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.product-section');
      if (!this.section) return;
      this.abort = new AbortController();
      this.schedule = () => queueMicrotask(() => { if (this.isConnected) this.sync(); });
      this.section.addEventListener('change', this.schedule, { capture: true, signal: this.abort.signal });
      this.section.addEventListener('theme:variant:change', this.schedule, { signal: this.abort.signal });
      document.addEventListener('DOMContentLoaded', this.schedule, { once: true, signal: this.abort.signal });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    sync() {
      const builder = this.section.querySelector('[data-okova-variant-builder]');
      const form = this.section.querySelector('form[data-product-form]');
      if (!builder || builder.dataset.initialized !== 'true' || !form) {
        this.hidden = true;
        return;
      }
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      if (this.input !== input) {
        this.observer?.disconnect();
        this.input = input;
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(input, { attributes: true, attributeFilter: ['value'] });
      }
      this.config ||= JSON.parse(this.querySelector('[data-okova-value-config]').textContent);
      const selects = Array.from(form.querySelectorAll('.product__form__select'));
      const variant = this.config.variants.find(item => selects.length === item.options.length && selects.every((select, index) => select.value === item.options[index]));
      const labels = this.config.labels;
      let text = '';
      if (variant) {
        const [connection, material] = variant.options.map(option => option.trim().toLowerCase());
        if (connection === 'clip on tail no plug' && material === 'clip on tail no plug') {
          text = labels.clipon;
        } else {
          const standard = connection.match(/^(small|medium|large) (attached|detachable)$/);
          const tug = connection.match(/^(small|medium|large) tug plug \(only metal plug\)$/);
          if (standard && ['silver metal plug', 'black silicone plug'].includes(material)) {
            text = [labels[standard[1]] + ' ' + (material === 'black silicone plug' ? labels.silicone : labels.metal), labels[standard[2]]].join(' · ');
          } else if (tug && material === 'silver metal plug') {
            text = [labels[tug[1]] + ' ' + labels.tug, labels.detachable].join(' · ');
          }
        }
      }
      const value = this.querySelector('[data-okova-value-selection]');
      if (value.textContent !== text) value.textContent = text;
      this.querySelector('[data-okova-value-setup]').hidden = !text;
      this.hidden = false;
    }
  });
})();
